import apiClient from '../utils/apiClient';
import { FileExistsDto, DeleteOrPublishTypeDto, DeleteTypeDto, FolderRequestDto, FolderSearchRequestDto, GetDescriptionDto, MoveFolderDto, PortalFileDto, PortalFolderDto, PublishDto, FolderExistsDto, FileDetailsDto } from '../types/Folder';
import { ResponseDto } from '../types/Helper';
import { GetFoldersByUserIdDto } from '../types/FolderPermission';

export const saveFolder = async (folderData?: PortalFolderDto): Promise<ResponseDto<number>> => {
  const response = await apiClient.post<ResponseDto<number>>('/portal/folder', folderData);
  return response.data;
};

export const unPublishFolderOrFile = async (updateData?: DeleteOrPublishTypeDto): Promise<boolean> => {
  const response = await apiClient.post<boolean>(`/portal/unPublish-by-type/${updateData?.userId}/${updateData?.folderFileType}/${updateData?.typeId}`);
  return response.data;
};

export const publishFolder = async (publishData?: PublishDto): Promise<boolean> => {
  const response = await apiClient.post<boolean>('/portal/publish-folder', publishData);
  return response.data;
};

export const saveFile = async (formData: FormData): Promise<ResponseDto<FileDetailsDto>> => {
  const response = await apiClient.post<ResponseDto<FileDetailsDto>>('/portal/file', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const editFile = async (fileData?: PortalFileDto): Promise<ResponseDto<boolean>> => {
  const response = await apiClient.post<ResponseDto<boolean>>(`/portal/file/${fileData?.fileId}`, fileData);
  return response.data;
};

export const getFoldersByParentFolder = async (folderRequest: FolderRequestDto): Promise<GetFoldersByUserIdDto[]> => {
  let folderUrl = `/portal/role/folders-by-userId-parentFolder/${folderRequest.userId}/${folderRequest.isDeleted}`;
  if (folderRequest.parentFolderId !== null) {
    folderUrl += `?parentFolderId=${folderRequest.parentFolderId}`;
  }

  const response = await apiClient.get<GetFoldersByUserIdDto[]>(folderUrl);
  return response.data;
};

export const getRecursiveFoldersBySearch = async (folderRequest: FolderSearchRequestDto): Promise<GetFoldersByUserIdDto[]> => {
  let folderUrl = `/portal/role/folders-by-search/${folderRequest.isDeleted}`;
  if (folderRequest.parentFolderId !== null) {
    folderUrl += `?parentFolderId=${folderRequest.parentFolderId}`;
  }

  const response = await apiClient.get<GetFoldersByUserIdDto[]>(folderUrl);
  return response.data;
};

export const deleteFolder = async (deleteTypeDto: DeleteTypeDto): Promise<boolean> => {
  const response = await apiClient.delete<boolean>(`/portal/delete-folder/${deleteTypeDto.userId}/${deleteTypeDto.typeId}`);
  return response.data;
};

export const deleteFile = async (deleteTypeDto: DeleteTypeDto): Promise<boolean> => {
  const response = await apiClient.delete<boolean>(`/portal/delete-file/${deleteTypeDto.userId}/${deleteTypeDto.typeId}`);
  return response.data;
};

export const moveFolder = async (moveData?: MoveFolderDto): Promise<boolean> => {
  const response = await apiClient.post<boolean>(`/portal/move-folderOrFile`, moveData);
  return response.data;
};
export const deleteFolderOrFile = async (moveData?: MoveFolderDto): Promise<boolean> => {
  const response = await apiClient.post<boolean>(`/portal/delete-folderOrFile`, moveData);
  return response.data;
};
export const checkFolderOrFileExistWhileMove = async (moveData?: MoveFolderDto): Promise<boolean> => {
  const response = await apiClient.get<boolean>(`/portal/exists-folderOrFile`,  {
      params: moveData,
    });
  return response.data;
};

export const getDescription = async (getDescriptionDto: GetDescriptionDto): Promise<string> => {
  const response = await apiClient.get<string>(`/portal/get-description/${getDescriptionDto.typeId}/${getDescriptionDto.isFolder}`);
  return response.data;
};

export const checkFolderExists = async (folderData?: FolderExistsDto): Promise<boolean> => {
  const response = await apiClient.post<boolean>('/portal/check-folder-exists', folderData);
  return response.data;
};

export const checkFileExists = async (fileDto?: FileExistsDto): Promise<boolean> => {
  const response = await apiClient.post<boolean>('/portal/check-file-exists', fileDto);
  return response.data;
};